import axios, { AxiosRequestConfig } from "axios";
import { Handlers } from "../helpers/handlers";
import { ApiParams } from "./types";
import {
  clearServiceUnavailable,
  isServiceUnavailableStatus,
  notifyServiceUnavailable,
  SERVICE_UNAVAILABLE_MESSAGE,
} from "../helpers/serviceUnavailable";

// @ts-ignore
const scriptURLString = document?.getElementById("search-form-script")?.src;
export const partnerId = scriptURLString
  ? new URL(scriptURLString).searchParams.get("partnerId") ??
  (process.env.REACT_APP_PARTNER_ID || "")
  : process.env.REACT_APP_PARTNER_ID || "";

export class ServiceBase {
  public static async callApi({
    data = null,
    method,
    url,
    baseURL,
    contentType,
    params,
  }: ApiParams) {
    const URLStr = process.env.REACT_APP_BASE_URL;
    const Url = `${URLStr}/api/v1`.replace("{{ID}}", partnerId);
    const apiToken = process.env.REACT_APP_API_TOKEN;

    const config: AxiosRequestConfig = {
      baseURL,
      data,
      method,
      url,
      params,
      withCredentials: false,
    };
    if (!config.baseURL) config.baseURL = baseURL || Url;

    config.headers ??= {};

    config.headers["Accept"] = "application/json";

    if (contentType) {
      config.headers["Content-Type"] = contentType;
    } else if (data !== null && data !== undefined) {
      config.headers["Content-Type"] = "application/json";
    }

    if (apiToken) {
      config.headers["X-GIG-API-Token"] = apiToken;
    }

    try {
      const response = await axios.request({
        ...config,
        headers: {
          ...config.headers,
        }
      });
      clearServiceUnavailable();

      return response.data;
    } catch (error: any) {
      if (Object.prototype.hasOwnProperty.call(error, "response")) {
        if (isServiceUnavailableStatus(error.response?.status)) {
          // The backend is temporarily down. Flag it so the widget can show a
          // friendly message instead of the generic error screen.
          notifyServiceUnavailable();
          Handlers.defaultErrorAPIHandler(
            SERVICE_UNAVAILABLE_MESSAGE,
            error.response.status
          );
          throw error;
        }

        Handlers.defaultErrorAPIHandler(
          error.response.data.error != null
            ? error.response.data.error
            : error.response.data,
          error.response.status
        );
        throw error;
      } else if (error.request) {
        Handlers.defaultErrorHandler(
          "An error occurred when sending the request, or the server did not respond in time"
        );
        throw error;
      }
    }
  }
}
